// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@tps/Overrides/Widgets/Brand/BrandGallery";
import { color, createFadeOutEffect, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
    color: "common.ui6",
    css: css`
        margin-bottom: 20px;
        text-align: center;
        ${({ viewType }: any) =>
            viewType === "gallery" &&
            css`
                text-align: left;
                margin-bottom: 16px;
                width: 100%;
            `}
    `,
};

listStyles.link = {
    css: css`
        display: flex;
    `,
};

listStyles.carouselWrapper = {
    css: css`
        position: relative;
        ${({ fadeEffectWidth, fadeEffectColor }: any) => {
            return css`
                > .carousel-main-wrapper::before {
                    ${createFadeOutEffect(fadeEffectWidth, "left", fadeEffectColor, true)}
                }
                > .carousel-main-wrapper::after {
                    ${createFadeOutEffect(fadeEffectWidth, "right", fadeEffectColor, true)}
                }
            `;
        }}
    `,
};

listStyles.carouselExtendedStyles = {
    container: {
        css: css`
            .swiper-slide {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        `,
    },
};

// gallery view styles
listStyles.imageWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
    `,
};

listStyles.image = {
    css: css`
        max-width: 100%;
        img {
            max-width: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        }
    `,
};

listStyles.brandName = {
    size: 18,
    lineHeight: "24px",
    weight: "bold",
    css: css`
        margin-bottom: 0;
        &&& {
            color: ${color("text")};
            &:hover {
                color: ${color("common.ui8")};
            }
        }
        justify-content: center;
        margin-top: 12px;
    `,
};
